export const OVERLAY_TECHNOLOGY = 'ceo'
